module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/eg-c6ff8d6c3057865a32f17e347d1916dd.svg";